export const AddressSubSchema = {
    title: 'Address',
    type: 'object',
    properties: {
        street: {
            title: 'Street',
            type: 'string',
            minLength: 1,
        },
        unit: {
            type: 'string',
        },
        city: {
            type: 'string',
            minLength: 1,
        },
        postalCode: {
            type: 'string',
            minLength: 5,
        },
        state: {
            type: 'string',
            minLength: 2,
        },
        normalizationResponse: {
            type: 'string',
        },
        forced: { type: 'boolean' },
    },
    required: ['street', 'city', 'postalCode', 'state', 'normalizationResponse'],
    ui: {
        component: 'address', // `address` indicates to use the AddressWidget
    },
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYWRkcmVzcy1zdWItc2NoZW1hLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL3NjaGVtYXMvYWRkcmVzcy1zdWItc2NoZW1hLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUVBLE1BQU0sQ0FBQyxNQUFNLGdCQUFnQixHQUFnQjtJQUMzQyxLQUFLLEVBQUUsU0FBUztJQUNoQixJQUFJLEVBQUUsUUFBUTtJQUNkLFVBQVUsRUFBRTtRQUNWLE1BQU0sRUFBRTtZQUNOLEtBQUssRUFBRSxRQUFRO1lBQ2YsSUFBSSxFQUFFLFFBQVE7WUFDZCxTQUFTLEVBQUUsQ0FBQztTQUNiO1FBQ0QsSUFBSSxFQUFFO1lBQ0osSUFBSSxFQUFFLFFBQVE7U0FDZjtRQUNELElBQUksRUFBRTtZQUNKLElBQUksRUFBRSxRQUFRO1lBQ2QsU0FBUyxFQUFFLENBQUM7U0FDYjtRQUNELFVBQVUsRUFBRTtZQUNWLElBQUksRUFBRSxRQUFRO1lBQ2QsU0FBUyxFQUFFLENBQUM7U0FDYjtRQUNELEtBQUssRUFBRTtZQUNMLElBQUksRUFBRSxRQUFRO1lBQ2QsU0FBUyxFQUFFLENBQUM7U0FDYjtRQUNELHFCQUFxQixFQUFFO1lBQ3JCLElBQUksRUFBRSxRQUFRO1NBQ2Y7UUFDRCxNQUFNLEVBQUUsRUFBRSxJQUFJLEVBQUUsU0FBUyxFQUFFO0tBQzVCO0lBQ0QsUUFBUSxFQUFFLENBQUMsUUFBUSxFQUFFLE1BQU0sRUFBRSxZQUFZLEVBQUUsT0FBTyxFQUFFLHVCQUF1QixDQUFDO0lBQzVFLEVBQUUsRUFBRTtRQUNGLFNBQVMsRUFBRSxTQUFTLEVBQUUsK0NBQStDO0tBQ3RFO0NBQ0YsQ0FBQyJ9